module.exports = __webpack_public_path__ + "static/media/sound-off-black.9969c1f8.png";